<template>
  <div class="modal-aside-bottom">
    <slot />
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.modal-aside-bottom {
  padding: 12px 16px;
  border-top: 1px solid #cacece;
  flex: 0 0 auto;
  @include point-md {
    padding: 16px 24px;
  }
}
</style>
